import { ChangeEvent, KeyboardEvent, useCallback, useEffect, useState } from 'react'

interface UseFolderTitleRenameParams {
  currentFolderName: string
  folderId: string
  renameItem: (params: { id: string; name: string; type: 'folder' }) => void
}

export const useFolderTitleRename = ({ currentFolderName, folderId, renameItem }: UseFolderTitleRenameParams) => {
  const [isRenaming, setIsRenaming] = useState(false)
  const [value, setValue] = useState(currentFolderName)

  useEffect(() => {
    if (!isRenaming) {
      setValue(currentFolderName)
    }
  }, [currentFolderName, isRenaming])

  const startRenaming = useCallback(() => {
    setValue(currentFolderName)
    setIsRenaming(true)
  }, [currentFolderName])

  const submit = useCallback(() => {
    const trimmed = value.trim()
    if (trimmed && trimmed !== currentFolderName) {
      renameItem({ id: folderId, name: trimmed, type: 'folder' })
    }
    setIsRenaming(false)
  }, [currentFolderName, folderId, renameItem, value])

  const cancel = useCallback(() => {
    setValue(currentFolderName)
    setIsRenaming(false)
  }, [currentFolderName])

  const handleBlur = submit

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }, [])

  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        submit()
      }
      if (e.key === 'Escape') {
        cancel()
      }
    },
    [cancel, submit],
  )

  return { handleBlur, handleChange, handleKeyDown, isRenaming, startRenaming, value }
}
